import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
    position: 'relative',
  },
  appBarSpacer: theme.mixins.toolbar
});
